/* The loon, drawn as two closed paths — the body and a separate pointed
   bill with a small gap at the base so the bill reads as its own shape.
   Both sit flush on the baseline (y=96) so the bird can rest directly on
   a waterline. Colored via currentColor so context (header, footer) sets
   the ink. Small placements use these plain shapes; the hero composes
   them with field marks and a reflection in LoonScene. Keep the paths in
   sync with public/favicon.svg. */

export const LOON_HULL =
  'M47.5 35 C48.5 26 52 19 58 17.2 C64 15.8 70 16.5 74.5 20 C80 25 85 34 89.5 46 C92 52 95 54.5 100 54 C118 49.5 145 49 170 53 C185 55.5 197 61 207 68 C213 72.5 219 80 221 87 L223 96 L54 96 C48 88 44.5 80 43.8 72 C43.4 65 44.5 57 46 50 C46.5 45 46.8 40 47.5 35 Z'

export const LOON_BILL =
  'M9 34.8 L45.2 35.6 C46 39 46.2 42.8 45.8 46 L11.5 37.6 C10 37 9 35.9 9 34.8 Z'

export function LoonMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 240 96"
      className={className}
      role="img"
      aria-label="Loonworks loon mark"
      fill="currentColor"
    >
      <path d={LOON_HULL} />
      <path d={LOON_BILL} />
      <circle cx="56" cy="26.5" r="2.1" fill="var(--paper, #f6f2e9)" />
    </svg>
  )
}
